import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';

export const ProgressBar = ({ progress }: { progress: number }) => (
  <Box width="100%">
    <Box bg="textWeak" height="2px" width={`${progress * 100}%`} />
  </Box>
);
